import type { FaireProductEntity } from "../../entity_types/product";

export const p_hwyrcvffxm: FaireProductEntity = {
  token: "p_hwyrcvffxm",
  type: "product",
  name: "Organic Cotton Knotted Sleeper",
  brandToken: "b_4l3jg0ght8",
  brandName: "Silkberry Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/814175913ff98bb3e6d8bda3d3cb6d8ea23db2797af7aff0777f15bdb89e36b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b1cd46e5a3521b5d68873e853a779cef7e47dc5607c28b0d973e61f319522812.jpeg",
    "https://cdn.faire.com/fastly/be3d1675fc0bdec1f9cf9445542bf5da51a1fbfc104e8b0b28e62708f627b636.jpeg",
    "https://cdn.faire.com/fastly/437f379eafb770fe1394b625d331f4be80ab0a253e27bbc5c7a0afcee7b25685.jpeg",
    "https://cdn.faire.com/fastly/b9ba19d4db04990b070595b915e3711348f84347c25f9e1141fdfa175eb9954c.jpeg",
  ],
  priceDollars: 11,
  description:
    "This super cute knotted gown is perfect for your new born baby. It’s made of soft organic cotton jersey and designed to keep baby cozy all year around. Open bottom for diaper changes day or night and has built in fold over scratch mitts.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:59.638Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
